import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { get } from 'lodash';
import dimensionListSelector from '@store/common/dimensionList/selectors';
import { filterColorSelector } from '@store/errorDiagnostics/selectors';
import baseSelector, {
  errorCodesSelector,
  filterColorsSelector,
  intervalPayloadSelector,
} from '@store/errorDiagnostics/base/selectors';
import errorTableSelector from '@store/errorDiagnostics/errorTable/selectors';
import dimensionTablesSelector, {
  payloadsSelector,
} from '@store/errorDiagnostics/dimensionTables/selectors';
import barChartSelector, {
  chartDataSelector,
} from '@store/errorDiagnostics/barChart/selectors';
import { sharingResponseSelector } from '@store/errorDiagnostics/sharing/selectors';
import * as baseActions from '@store/errorDiagnostics/base/actions';
import * as errorTableActions from '@store/errorDiagnostics/errorTable/actions';
import * as dimensionTablesActions from '@store/errorDiagnostics/dimensionTables/actions';
import * as barChartActions from '@store/errorDiagnostics/barChart/actions';
import * as commonActions from '@store/common/actions';
import { toggleUpdatePopupVisible } from '@store/dashboards/ui/actions';
import { selectors as sharedTabsSelector, deleteSharedTab } from '@src/store/sharedTabs';
import { exportWidgetData } from '@store/export/actions';
import ExportMenuItem from '@components/common/Export/Menu';
import { selector as commonSelector } from '@store/common';
import Migrate from './Migrate';

const selector = createSelector(
  baseSelector,
  filterColorSelector,
  intervalPayloadSelector,
  errorTableSelector,
  dimensionListSelector,
  dimensionTablesSelector,
  errorCodesSelector,
  barChartSelector,
  chartDataSelector,
  filterColorsSelector,
  sharingResponseSelector,
  payloadsSelector,
  sharedTabsSelector,
  commonSelector,
  (
    baseStore,
    filterColor,
    intervalPayload,
    errorTable,
    dimensionList,
    dimensionTables,
    errorCodes,
    barChart,
    barChartData,
    filterColors,
    sharingStore,
    payloadsStore,
    sharedTabsStore,
    commonStore,
  ) => ({
    currentErrorCode: baseStore.currentErrorCode,
    base: baseStore,
    filterColor,
    intervalPayload,
    errorTable,
    dimensionList,
    dimensionTables,
    errorCodes,
    barChart,
    barChartData,
    filterColors,
    sharingData: sharingStore,
    payloadFilter: get(payloadsStore, [0, 'queries', 0, 'filter'], []),
    sharedTabs: sharedTabsStore.tabs,
    features: commonStore.features,
  }),
);

export default connect(
  selector,
  {
    addNewDashboard: commonActions.addNewDashboard,
    errorTableRequest: errorTableActions.initRequest,
    errorTableFetching: errorTableActions.fetching,
    addErrorCode: baseActions.addErrorCode,
    removeErrorCode: baseActions.removeErrorCode,
    setCurrentErrorCode: baseActions.setCurrentErrorCode,
    initDimensionTablesRequests: dimensionTablesActions.initRequests,
    startDimensionTablesFetching: dimensionTablesActions.startFetching,
    setUnit: dimensionTablesActions.setUnit,
    setDimension: dimensionTablesActions.setDimension,
    refreshDimension: dimensionTablesActions.refreshDimension,
    switchDimension: dimensionTablesActions.switchDimension,
    barChartInit: barChartActions.initRequest,
    barChartFetching: barChartActions.fetching,
    toggleUpdatePopupVisible,
    deleteSharedTab,
    exportWidgetData,
    ExportMenuItem,
  },
)(Migrate);
